import * as React from "react";
import type { SVGProps } from "react";
const SvgCheckIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect width="21" height="21" rx="10.5" fill="#38BA9C"/>
        <path d="M4 10.5L5.625 9L8.875 12L15.375 6L17 7.5L8.875 15L4 10.5Z" fill="white"/>
    </svg>
)
export default SvgCheckIcon;

